const { createAction } = require("../../helpers");
const {
  CREATE_TRANSACTION,
  CREATE_TRANSACTION_SUCCESS,
  CREATE_TRANSACTION_ERROR,
  CREATE_TRANSACTION_RESET,

  GET_INVOICE,
  GET_INVOICE_SUCCESS,
  GET_INVOICE_ERROR,
  GET_INVOICE_RESET,

  GET_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_ERROR,
  GET_TRANSACTIONS_RESET,

  GET_TRANSACTION,
  GET_TRANSACTION_SUCCESS,
  GET_TRANSACTION_ERROR,
  GET_TRANSACTION_RESET,

  UPDATE_ADDRESS,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_ERROR,
  UPDATE_ADDRESS_RESET,

  CART_CHECKOUT,
  CART_CHECKOUT_SUCCESS,
  CART_CHECKOUT_ERROR,
  CART_CHECKOUT_RESET,

  TRANSACTION_DELIVERY,
  TRANSACTION_DELIVERY_SUCCESS,
  TRANSACTION_DELIVERY_ERROR,
  TRANSACTION_DELIVERY_RESET,

  DELIVERY_PRICELIST,
  DELIVERY_PRICELIST_SUCCESS,
  DELIVERY_PRICELIST_ERROR,
  DELIVERY_PRICELIST_RESET,

  DELIVERY_LIST_PROVIDERS,
  DELIVERY_LIST_PROVIDERS_SUCCESS,
  DELIVERY_LIST_PROVIDERS_ERROR,
  DELIVERY_LIST_PROVIDERS_RESET,
} = require("./constants");

const createTransaction = (data) => createAction(CREATE_TRANSACTION, { data });
const createTransactionSuccess = (transaction) =>
  createAction(CREATE_TRANSACTION_SUCCESS, { transaction });
const createTransactionError = (error) =>
  createAction(CREATE_TRANSACTION_ERROR, { error });
const createTransactionReset = () => createAction(CREATE_TRANSACTION_RESET);

const getInvoice = (uuid) => createAction(GET_INVOICE, { uuid });
const getInvoiceSuccess = (html) => createAction(GET_INVOICE_SUCCESS, { html });
const getInvoiceError = (error) => createAction(GET_INVOICE_ERROR, { error });
const getInvoiceReset = () => createAction(GET_INVOICE_RESET);

const getTransactions = (page, pageSize) =>
  createAction(GET_TRANSACTIONS, { page, pageSize });
const getTransactionsSuccess = (transaction) =>
  createAction(GET_TRANSACTIONS_SUCCESS, { transaction });
const getTransactionsError = (error) =>
  createAction(GET_TRANSACTIONS_ERROR, { error });
const getTransactionsReset = () => createAction(GET_TRANSACTIONS_RESET);

const getTransaction = ({ uuid, isBusiness }) =>
  createAction(GET_TRANSACTION, { uuid, isBusiness });
const getTransactionSuccess = (transaction) =>
  createAction(GET_TRANSACTION_SUCCESS, { transaction });
const getTransactionError = (error) =>
  createAction(GET_TRANSACTION_ERROR, { error });
const getTransactionReset = () => createAction(GET_TRANSACTION_RESET);

const updateAddress = ({ refId, addressId }) =>
  createAction(UPDATE_ADDRESS, { refId, addressId });
const updateAddressSuccess = (transaction) =>
  createAction(UPDATE_ADDRESS_SUCCESS, { transaction });
const updateAddressError = (error) =>
  createAction(UPDATE_ADDRESS_ERROR, { error });
const updateAddressReset = () => createAction(UPDATE_ADDRESS_RESET);

const cartCheckOut = (data) => createAction(CART_CHECKOUT, { data });
const cartCheckOutSuccess = (transaction) =>
  createAction(CART_CHECKOUT_SUCCESS, { transaction });
const cartCheckOutError = (error) =>
  createAction(CART_CHECKOUT_ERROR, { error });
const cartCheckOutReset = () => createAction(CART_CHECKOUT_RESET);

const transactionDelivery = ({ orderId, refId, providerId }) =>
  createAction(TRANSACTION_DELIVERY, { orderId, refId, providerId });
const transactionDeliverySuccess = (data) =>
  createAction(TRANSACTION_DELIVERY_SUCCESS, { data });
const transactionDeliveryError = (error) =>
  createAction(TRANSACTION_DELIVERY_ERROR, { error });
const transactionDeliveryReset = () => createAction(TRANSACTION_DELIVERY_RESET);

const deliveryPricelist = ({ orderId, refId }) =>
  createAction(DELIVERY_PRICELIST, { orderId, refId });
const deliveryPricelistSuccess = (data) =>
  createAction(DELIVERY_PRICELIST_SUCCESS, { data });
const deliveryPricelistError = (error) =>
  createAction(DELIVERY_PRICELIST_ERROR, { error });
const deliveryPricelistReset = () => createAction(DELIVERY_PRICELIST_RESET);

const deliveryProviderslist = (id) =>
  createAction(DELIVERY_LIST_PROVIDERS, { id });
const deliveryProviderslistSuccess = (data) =>
  createAction(DELIVERY_LIST_PROVIDERS_SUCCESS, { data });
const deliveryProviderslistError = (error) =>
  createAction(DELIVERY_LIST_PROVIDERS_ERROR, { error });
const deliveryProviderslistReset = () =>
  createAction(DELIVERY_LIST_PROVIDERS_RESET);

module.exports = {
  createTransaction,
  createTransactionSuccess,
  createTransactionError,
  createTransactionReset,

  getInvoice,
  getInvoiceSuccess,
  getInvoiceError,
  getInvoiceReset,

  getTransactions,
  getTransactionsSuccess,
  getTransactionsError,
  getTransactionsReset,

  getTransaction,
  getTransactionSuccess,
  getTransactionError,
  getTransactionReset,

  updateAddress,
  updateAddressSuccess,
  updateAddressError,
  updateAddressReset,

  cartCheckOut,
  cartCheckOutSuccess,
  cartCheckOutError,
  cartCheckOutReset,

  transactionDelivery,
  transactionDeliverySuccess,
  transactionDeliveryError,
  transactionDeliveryReset,

  deliveryPricelist,
  deliveryPricelistSuccess,
  deliveryPricelistError,
  deliveryPricelistReset,

  deliveryProviderslist,
  deliveryProviderslistSuccess,
  deliveryProviderslistError,
  deliveryProviderslistReset,
};
